import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../config/config.service';
import { Parametro } from '../../../types/Parametro.type';

@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getList(){
    return this.httpClient.get<Parametro[]>(`${this.configService.getApiUrlIntegrador()}/parametros/`)
  }
  put(parametro: Parametro){
    return this.httpClient.put(`${this.configService.getApiUrlIntegrador()}/parametros/`, parametro)
  }

  buscarParametro(instancia: string, secao: string, entrada: string): Observable<Parametro> {
    let params = new HttpParams()
      .set('secao', secao)
      .set('entrada', entrada);
    if (instancia) {
      params = params.set('instancia', instancia);
    }
    return this.httpClient.get<Parametro>(`${this.configService.getApiUrlRoot()}/parametros/filtros`, { params });
  }
}
